import { FC } from 'react'

type CommentsTitleProps = {
  title?: string
}

export const CommentsTitle: FC<CommentsTitleProps> = ({ title }) => {
  return (
    <div className="relative flex items-center justify-center">
      <span className="absolute left-0 right-0 top-1/2 z-[1] block h-1 -translate-y-1/2 bg-[#DDDEDF]" />
      <span className="relative z-[2] w-max bg-white px-24 py-6 text-grey-50 text-14">
        {title}
      </span>
    </div>
  )
}

export default CommentsTitle
